import React from 'react';
import { useTour } from '../../context/TourContext';
import { Play } from 'lucide-react';

export default function TourButton() {
  const { startTour, isOpen } = useTour();

  if (isOpen) return null; // Hide button during tour

  return (
    <button
      onClick={startTour}
      className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg hover:from-blue-700 hover:to-purple-700 shadow-lg transition-all duration-200 hover:shadow-xl"
      title="Start Interactive Tour"
    >
      <Play size={16} />
      Take a Tour
    </button>
  );
}
